import { render, staticRenderFns } from "./phoneTag.vue?vue&type=template&id=7f2e78d8&scoped=true"
import script from "./phoneTag.vue?vue&type=script&lang=js"
export * from "./phoneTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2e78d8",
  null
  
)

export default component.exports